define([
	"dojo/_base/declare",
	"csi/heading/Ref",
	"./_ValueAttributeMixin"
], function(declare,Ref,ValueAttributeMixin) {

	return declare([Ref,ValueAttributeMixin], {

	});
});
